import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/feature/PageMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';

const milestones = [
  { year: '2010', title: '品牌创立', desc: '爱威奶品牌在内蒙古呼和浩特正式成立，致力于为消费者提供优质乳制品。' },
  { year: '2013', title: '自有牧场', desc: '在呼伦贝尔大草原建立自有牧场，从源头把控奶源品质。' },
  { year: '2016', title: '产品线拓展', desc: '从纯牛奶拓展至酸奶、儿童奶、高钙奶等多条产品线。' },
  { year: '2019', title: '线上平台上线', desc: '爱威奶在线官方购买平台正式上线，开启线上线下融合新零售模式。' },
  { year: '2022', title: '有机认证', desc: '获得中国有机产品认证，有机纯牛奶系列正式上市。' },
  { year: '2026', title: 'GAP国际认证', desc: '自有牧场通过国际GAP认证，品质管理达到国际先进水平。' },
];

const certifications = [
  { icon: 'ri-shield-check-line', name: 'ISO 22000', desc: '食品安全管理体系认证' },
  { icon: 'ri-leaf-line', name: '中国有机认证', desc: '有机产品认证证书' },
  { icon: 'ri-medal-line', name: 'GAP认证', desc: '国际良好农业规范认证' },
  { icon: 'ri-award-line', name: 'HACCP认证', desc: '危害分析与关键控制点认证' },
];

export default function About() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState('');
  const [formLoading, setFormLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');
    setFormLoading(true);

    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="company_alt"]') as HTMLInputElement)?.value.trim();

    if (honeypot) {
      setFormSubmitted(true);
      setFormLoading(false);
      return;
    }

    try {
      const formData = new FormData(form);
      const formDataObj: Record<string, string> = {};
      formData.forEach((val, key) => {
        if (key !== 'company_alt') {
          formDataObj[key] = val as string;
        }
      });

      const body = new URLSearchParams(formDataObj).toString();
      const response = await fetch('https://readdy.ai/api/form/d9pmuupn2trhb35gvi70', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setFormSubmitted(true);
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后再试';
        if (msg.toLowerCase().includes('spam')) {
          setFormError('提交失败，请稍后再试');
        } else {
          setFormError(msg);
        }
      }
    } catch {
      setFormError('网络异常，请检查网络后重试');
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <>
      <PageMeta
        title="关于我们 - 爱威奶在线 | 品牌介绍与联系方式"
        description="爱威奶品牌创立于2010年，总部位于内蒙古呼和浩特。拥有自有牧场和国际认证，致力于为消费者提供天然、健康、安全的优质乳制品。了解爱威奶品牌故事、品质保障与联系方式。"
        keywords="爱威奶品牌介绍,爱威奶联系方式,爱威奶品质保障,爱威奶品牌故事"
        canonicalUrl="https://www.aiweinai.com/about"
      />

      <Navbar />

      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <Breadcrumb items={[
            { label: '首页', to: '/' },
            { label: '关于我们' },
          ]} />

          {/* Brand Intro */}
          <section className="mt-6 mb-16">
            <div className="flex flex-col lg:flex-row items-start gap-10">
              <div className="flex-1">
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-5">
                  关于<strong className="text-primary-600">爱威奶在线</strong>
                </h1>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  爱威奶品牌创立于2010年，总部位于中国乳都——内蒙古呼和浩特市。十余年来，我们始终秉承"天然、健康、安全"的品牌理念，致力于为每一位消费者提供最优质的乳制品。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  我们在呼伦贝尔大草原拥有自有牧场，地处北纬47°黄金奶源带，空气清新、水草丰美，为奶牛提供了最适宜的生长环境。从牧场到餐桌，我们建立了完善的质量管控体系，确保每一滴牛奶都安全可追溯。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  爱威奶在线是爱威奶官方正品购买平台，汇聚全系列产品，支持在线下单、冷链配送、售后保障，让您足不出户即可享受新鲜优质的牛奶产品。
                </p>
              </div>
              <div className="w-full lg:w-[420px] flex-shrink-0 aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20dairy%20factory%20exterior%20with%20clean%20white%20architecture%20and%20green%20landscape%2C%20bright%20natural%20light%2C%20cream%20warm%20tones%2C%20minimalist%20architectural%20photography%2C%20professional%20corporate%20image%2C%20high%20quality%2C%20clean%20composition&width=840&height=630&seq=about-brand-01&orientation=landscape"
                  alt="爱威奶品牌总部"
                  title="爱威奶品牌总部 - 内蒙古呼和浩特"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          {/* Milestones */}
          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-8 text-center">
              品牌发展历程
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {milestones.map((m, i) => (
                <div key={i} className="flex gap-4 p-5 bg-background-50 rounded-lg border border-background-200/70">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-50 text-accent-600 flex-shrink-0 text-sm font-bold">
                    {m.year}
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">{m.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Certifications */}
          <section className="mb-16 bg-background-100 rounded-lg p-8 md:p-10">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-3 text-center">
              品质认证与保障
            </h2>
            <p className="text-sm text-foreground-500 text-center mb-8 max-w-xl mx-auto">
              多项国际国内权威认证，为您提供最值得信赖的产品品质保障
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {certifications.map((cert, i) => (
                <div key={i} className="flex flex-col items-center text-center p-5 bg-background-50 rounded-lg">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-3">
                    <i className={`${cert.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{cert.name}</h3>
                  <p className="text-xs text-foreground-500">{cert.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              {/* Contact Info */}
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 flex-shrink-0">
                    <i className="ri-phone-fill"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服热线</h3>
                    <p className="text-sm text-foreground-500">400-888-9999</p>
                    <p className="text-xs text-foreground-400">工作时间：周一至周日 9:00 - 21:00</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-fill"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-500">service@aiweinai.com</p>
                    <p className="text-xs text-foreground-400">我们会在24小时内回复您的邮件</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 flex-shrink-0">
                    <i className="ri-map-pin-fill"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-500">内蒙古呼和浩特市乳业开发区爱威奶大道88号</p>
                    <p className="text-xs text-foreground-400">欢迎来访，请提前预约</p>
                  </div>
                </div>
              </div>

              {/* Contact Form */}
              <div className="bg-background-50 rounded-lg border border-background-200/70 p-6">
                <h3 className="text-base font-semibold text-foreground-900 mb-5">在线留言</h3>

                {formSubmitted ? (
                  <div className="text-center py-10">
                    <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-50 text-primary-600">
                      <i className="ri-check-line text-2xl"></i>
                    </div>
                    <p className="text-sm font-medium text-foreground-900 mb-1">提交成功！</p>
                    <p className="text-xs text-foreground-500">感谢您的留言，我们会尽快与您联系。</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} data-readdy-form="">
                    <div className="space-y-4">
                      <div>
                        <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-700 mb-1.5">姓名</label>
                        <input
                          id="contact-name"
                          name="name"
                          type="text"
                          required
                          className="w-full px-3 py-2.5 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
                        <input
                          id="contact-email"
                          name="email"
                          type="email"
                          required
                          className="w-full px-3 py-2.5 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-phone" className="block text-xs font-medium text-foreground-700 mb-1.5">电话</label>
                        <input
                          id="contact-phone"
                          name="phone"
                          type="tel"
                          className="w-full px-3 py-2.5 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                          placeholder="请输入您的电话（选填）"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
                        <textarea
                          id="contact-message"
                          name="message"
                          required
                          maxLength={500}
                          rows={4}
                          className="w-full px-3 py-2.5 text-sm border border-background-200/70 rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                          placeholder="请输入您的留言内容（限500字）"
                        ></textarea>
                      </div>
                      {/* Honeypot */}
                      <input
                        type="text"
                        name="company_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                        className="honeypot-field"
                      />
                      {formError && (
                        <p className="text-xs text-red-500">{formError}</p>
                      )}
                      <button
                        type="submit"
                        disabled={formLoading}
                        className="w-full py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                      >
                        {formLoading ? '提交中...' : '提交留言'}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </section>

          {/* Map */}
          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-6 text-center">
              公司位置
            </h2>
            <div className="w-full aspect-[16/7] rounded-lg overflow-hidden bg-background-100">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d195324.78751234567!2d111.6!3d40.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35df3c3c3c3c3c3c%3A0x3c3c3c3c3c3c3c3c!2z5YaF6JKZ5Y-k5ZCR6b6Z5biC!5e0!3m2!1szh-CN!2scn!4v1690000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="爱威奶公司位置地图"
              ></iframe>
            </div>
          </section>
        </div>
      </main>

      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于我们 - 爱威奶在线",
          "description": "爱威奶品牌创立于2010年，总部位于内蒙古呼和浩特。拥有自有牧场和国际认证，致力于为消费者提供天然、健康、安全的优质乳制品。",
          "url": "https://www.aiweinai.com/about",
          "about": {
            "@type": "Organization",
            "name": "爱威奶在线",
            "url": "https://www.aiweinai.com",
            "description": "爱威奶官方正品购买平台",
            "foundingDate": "2010",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "呼和浩特",
              "addressRegion": "内蒙古",
              "addressCountry": "CN",
              "streetAddress": "乳业开发区爱威奶大道88号",
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+86-400-888-9999",
              "contactType": "customer service",
              "areaServed": "CN",
              "availableLanguage": "Chinese",
            },
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.aiweinai.com" },
              { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "https://www.aiweinai.com/about" },
            ],
          },
        }),
      }} />
    </>
  );
}